import Vue from 'vue';
import request from '../../request';

export default {
  namespaced: true,
  state: {
    loaded: false,
    data: {
      id: '',
      first_name: '',
      last_name: '',
      residency_country_id: '',
      nationality_country_id: '',
      id_card_number: '',
      birth_date: '',
      phone_number: '',
    },
    form: {
      id: '',
      first_name: '',
      last_name: '',
      residency_country_id: '',
      nationality_country_id: '',
      fiscal_number: '',
      id_card_number: '',
      birth_date: '',
      phone_number: '',
    },
    errors: {},
  },
  mutations: {
    set(state, data) {
      Object.assign(state.data, data);
      Object.assign(state.form, data);
      Object.assign(state, { loaded: true });
    },
    setFormValue(state, data) {
      Object.assign(state.form, data);
    },
    setFormErrors(state, errors) {
      Vue.set(state, 'errors', errors);
    },
  },
  actions: {
    get(context) {
      request.make({
        type: 'GET',
        url: `${process.env.API_URL}client/${context.rootState.userDeprecated.data.username}`,
      }, (err, res) => {
        if (res.status === 200) {
          context.commit('set', res.body.data);
          setTimeout(() => {
            window.Materialize.updateTextFields();
          }, 500);
        }
      });
    },
    save(context) {
      return new Promise((resolve, reject) => {
        const data = context.state.form;
        request.make({
          type: 'PUT',
          url: `${process.env.API_URL}client`,
          data,
        }, (err, res) => {
          if (res.status === 204) {
            context.commit('setFormErrors', {});
            context.commit('setShowAllValidationErrors', false, { root: true });
            resolve();
          } else {
            context.commit('setShowAllValidationErrors', true, { root: true });
            context.dispatch('showSaveError', undefined, { root: true });
            context.commit('setFormErrors', res.body.errors);
            reject();
          }
        });
      });
    },
    setFormValue(context, payload) {
      context.commit('setFormValue', payload);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/public/client.js